import { useMutation as e } from "@maat/store-hooks";
import { adminMarketingApi as t } from "@maat/api-main";
//#region src/marketing/admin/useUploadMarketingImageMutation.ts
var n = () => e({ mutationFn: (e) => t.uploadImage(e) });
//#endregion
export { n as useUploadMarketingImageMutation };
